import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  //定义状态
  state: {
    LineGID: null,
    LineClassDayGID: null,
    QueryTime: new Date(),
    LineName: null,
    LineClassDayName: null,
    baseColor: window.localStorage.getItem("isShowCyw") == "false" ? '#5487DF' : '#eb5c03',  // 车盈网橘色 #eb5c03    非定制蓝色 #5487DF
    adminInfo: {},
    CompInfo: {} // CompGID、CompName
  },
  getters: {
    getLineGID(state) {
      return state.LineGID
    },
    getLineClassDayGID(state) {
      return state.LineClassDayGID
    },
    getBaseColor(state) {
      return state.baseColor
    },
    getCompInfo(state) {
      let admininfo = JSON.parse(window.localStorage.getItem('adminInfo') || '{}')
      // let admininfo = state.adminInfo || {};
      return state.CompInfo && state.CompInfo.CompGID ? state.CompInfo : {
        CompGID: admininfo.CompGID,
        CompName: admininfo.CompName
      };
    }
  },
  //更改状态信息
  mutations: {
    newLineGID(state, LineGID) {
      state.LineGID = LineGID;
    },
    newLineClassDayGID(state, LineClassDayGID) {
      state.LineClassDayGID = LineClassDayGID
    },
    newCompInfo(state, CompInfo) {
      state.CompInfo = CompInfo
    },

  },
  //应用mutation
  actions: {
    getNewLineGID(context, LineGID) {
      context.commit('newLineGID', LineGID)
    },
    getNewLineClassDayGID(context, LineClassDayGID) {
      context.commit('newLineClassDayGID', LineClassDayGID)
    },
    setCompInfo(context, CompInfo) {
      context.commit('newCompInfo', CompInfo)
    },
  }
})
